module.exports = __webpack_public_path__ + "media/images/lalamove-allcare-d3007d9ecc22aebf08f6534b61d8d2df.png";